// extracted by css-extract-rspack-plugin
export default {"container":"DurationField_container__Wb-oD"};